export const STATUS_OPTIONS = [
  { value: 'PENDING', label: 'Pending' },
  { value: 'WAITLIST', label: 'Waitlist' },
  { value: 'APPROVED', label: 'Accepted' },
  { value: 'ASSIGNED', label: 'Assigned' },
  { value: 'READY_FOR_PICKUP', label: 'Ready for Pickup' },
  { value: 'ENROUTE', label: 'Enroute' },
  { value: 'DELIVERED', label: 'Delivered' },
  { value: 'INVOICED', label: 'Invoiced' },
  { value: 'CUSTOMER_CANCELLED', label: 'Cancelled' },
  { value: 'PREPAY_REQUIRED', label: 'Prepay Required' },
  { value: 'PICKED_UP', label: 'Picked Up' },
  { value: 'ON_HOLD', label: 'Frozen' },
  { value: 'INVENTORY', label: 'Inventory' },
];

/**
 * Statuses that only make sense while a carrier is on the load. Pulling the
 * carrier off one of these drops the load back to APPROVED so it resurfaces as
 * needing dispatch instead of sitting "Enroute" with nobody hauling it.
 *
 * The same rule lives server-side in `lib/orders.ts` — keep them in step.
 */
export const CARRIER_DEPENDENT_STATUSES = ['ASSIGNED', 'READY_FOR_PICKUP', 'ENROUTE'];

/** Statuses where a carrier is part of live dispatch rather than a record. */
export const CARRIER_EDITABLE_STATUSES = ['APPROVED', 'ASSIGNED', 'READY_FOR_PICKUP', 'ENROUTE'];

/** A PENDING load has no warehouse or fee yet, so nothing to haul. Everything
 * else can take a carrier, terminal statuses included — recording who hauled a
 * delivered or invoiced load is the point. */
export const canAssignCarrierFromStatus = (status: string): boolean => status !== 'PENDING';

/** Statuses where attaching a carrier IS the dispatch step. Elsewhere it only
 * records the carrier — advancing would drag a finished load back to ASSIGNED. */
export const CARRIER_ADVANCES_TO_ASSIGNED_FROM = [...CARRIER_EDITABLE_STATUSES, 'PREPAY_REQUIRED'];

/** `PAID` needs the prepay flag to read: pre-dispatch for a prepay customer,
 * terminal for everyone else. */
export const assigningCarrierAdvancesStatus = (status: string, requiresPrepay: boolean): boolean =>
  CARRIER_ADVANCES_TO_ASSIGNED_FROM.includes(status) || (requiresPrepay && status === 'PAID');
